// Programarea făcută de elev: pachetul nou doar după ultima lui lecție (aceeași regulă ca pe server,
// BOOK_AFTER_LAST_LESSON). Sectorul, cutia și instructorii pot fi alții.
// Orele din bază sunt „de perete” la Chișinău scrise ca UTC: ziua = primele 10 caractere ale ISO.

export const BOOK_AFTER_LAST_LESSON = "BOOK_AFTER_LAST_LESSON";

/** Bara laterală (instructorul inventat 1) e o listă de așteptare, nu o lecție. */
const LATERAL_INSTRUCTOR_ID = 1;

const isoDay = (value) => {
   if (value == null) return null;
   const d = new Date(value);
   return Number.isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
};

/** Ziua ultimei lecții vii ("YYYY-MM-DD"); anulate, șterse și Bara laterală nu contează. null = n-are lecții. */
export function lastLessonDay(reservations) {
   let last = null;
   for (const r of reservations || []) {
      if (!r || r.deletedAt || r.isCancelled === true) continue;
      const instructorId = Number(r.instructorId ?? r.instructor?.id);
      if (instructorId === LATERAL_INSTRUCTOR_ID) continue;
      const day = isoDay(r.startTime ?? r.startDate);
      if (day && (!last || day > last)) last = day;
   }
   return last;
}

/** "2026-11-20" → "2026-11-21" */
export function nextDay(day) {
   const [y, m, d] = day.split("-").map(Number);
   return new Date(Date.UTC(y, m - 1, d + 1)).toISOString().slice(0, 10);
}

/** Prima zi în care elevul se poate programa: mâine sau ziua de după ultima lecție, care e mai târziu. */
export function firstBookableDay(lastDay, tomorrowDay) {
   if (!lastDay) return tomorrowDay;
   const after = nextDay(lastDay);
   return after > tomorrowDay ? after : tomorrowDay;
}

/** "2026-11-20" → "20.11.2026" */
export function formatDayRO(day) {
   const [y, m, d] = String(day).split("-");
   return `${d}.${m}.${y}`;
}

export function bookAfterLastLessonMessage(lastDay) {
   return `Poți programa doar după ultima ta lecție (${formatDayRO(lastDay)}).`;
}

/** Ziua "YYYY-MM-DD" ca dată locală la prânz (pentru calendarul din formular). */
export function dayToLocalDate(day) {
   const [y, m, d] = day.split("-").map(Number);
   return new Date(y, m - 1, d, 12, 0, 0, 0);
}

/** Refuzul serverului pentru regula asta: { lastLessonDay, message } sau null. */
export function readBookAfterLastLessonError(error) {
   const body = error?.payload;
   if (!body || typeof body !== "object" || body.code !== BOOK_AFTER_LAST_LESSON) return null;
   const lastDay = typeof body.lastLessonDay === "string" ? body.lastLessonDay : null;
   return {
      lastLessonDay: lastDay,
      message: body.message || (lastDay ? bookAfterLastLessonMessage(lastDay) : ""),
   };
}
